import { ReactNode } from 'react'

import { KW } from './theme'

export const ArrowUpRight = ({ size = 11 }: { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 17L17 7" />
    <path d="M8 7h9v9" />
  </svg>
)

interface Props {
  children: ReactNode
  onClick?: () => void
  title?: string
}

/** Teal source-reference pill ("IM-1234 ↗") — always built from server citations. */
const CitationPill = ({ children, onClick, title }: Props) => (
  <button
    type="button"
    title={title}
    onClick={onClick}
    className="inline-flex cursor-pointer items-center gap-1 rounded-full px-[9px] py-[3px] text-[11.5px] font-bold"
    style={{
      color: KW.teal500,
      background: KW.soft,
      border: `1px solid ${KW.softBorder}`,
      fontFamily: 'inherit',
    }}
  >
    {children}
    <ArrowUpRight />
  </button>
)

export default CitationPill
